module.exports = __webpack_public_path__ + "static/img/bantai(2).68bdb21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bantai(2).png
// module id = nB5S
// module chunks = 1